<div class="registration">
  <div class="registration-card">
    <ng-container *ngIf="!isRegistered; else registrationSuccess">
      <div class="logo-image">
        <img src="assets/img/logo.jpg" alt="Logo" />
      </div>

      <h1 class="title">
        {{ 'BROKER-REGISTRATION.TITLE' | translate }}
      </h1>

      <p class="description">
        {{ 'BROKER-REGISTRATION.DESCRIPTION' | translate }}
      </p>

      <app-panel>
        <div class="form-container">
          <dx-form
            #form
            labelMode="floating"
            [showColonAfterLabel]="false"
            [formData]="formData"
          >
            <dxi-item
              dataField="firstName"
              [label]="{ 
                text: ('COMMON.FIELDS.FIRST-NAME' | translate) 
              }"
            >
              <dxi-validation-rule
                type="required"
                [message]="'VALIDATIONS.FIRST-NAME-REQUIRED' | translate"
              />
            </dxi-item>

            <dxi-item
              dataField="lastName"
              [label]="{ 
                text: ('COMMON.FIELDS.LAST-NAME' | translate) 
              }"
            >
              <dxi-validation-rule
                type="required"
                [message]="'VALIDATIONS.LAST-NAME-REQUIRED' | translate"
              />
            </dxi-item>

            <dxi-item
              dataField="email"
              [label]="{ 
                text: ('COMMON.FIELDS.EMAIL' | translate) 
              }"
            >
              <dxi-validation-rule
                type="required"
                [message]="'VALIDATIONS.EMAIL-REQUIRED' | translate"
              />
              <dxi-validation-rule
                type="email"
                [message]="'VALIDATIONS.EMAIL-INVALID' | translate"
              />
            </dxi-item>

            <dxi-item
              dataField="company"
              [label]="{ 
                text: ('COMMON.FIELDS.COMPANY' | translate) 
              }"
            >
              <dxi-validation-rule
                type="required"
                [message]="'VALIDATIONS.COMPANY-REQUIRED' | translate"
              />
            </dxi-item>

            <dxi-item
              dataField="phone"
              [label]="{ 
                text: ('COMMON.FIELDS.PHONE-MOBILE' | translate) 
              }"
            />

            <dxi-item
              dataField="password"
              editorType="dxTextBox"
              [editorOptions]="{ mode: 'password' }"
              [label]="{ 
                text: ('COMMON.FIELDS.PASSWORD' | translate) 
              }"
            >
              <dxi-validation-rule
                type="required"
                [message]="'VALIDATIONS.PASSWORD-REQUIRED' | translate"
              />
              <dxi-validation-rule
                type="custom"
                [message]="'USER-NAV.CHANGE-PASSWORD-MODAL.PASSWORD-HINT' | translate"
                [validationCallback]="passwordComplexityCheck"
              ></dxi-validation-rule>
            </dxi-item>

            <dxi-item
              dataField="passwordConfirmation"
              editorType="dxTextBox"
              [editorOptions]="{ mode: 'password' }"
              [label]="{ 
                text: ('COMMON.FIELDS.REPEAT-PASSWORD' | translate) 
              }"
            >
              <dxi-validation-rule
                type="required"
                [message]="'VALIDATIONS.REPEAT-PASSWORD-REQUIRED' | translate"
              />
              <dxi-validation-rule
                type="custom"
                [message]="'VALIDATIONS.PASSWORDS-DO-NOT-MATCH' | translate"
                [validationCallback]="repeatPasswordValidation"
              ></dxi-validation-rule>
            </dxi-item>
          </dx-form>

          <div class="actions-container">
            <dx-button
              class="submit-button"
              color="primary"
              [text]="'COMMON.REGISTER' | translate"
              (onClick)="register()"
            />
          </div>
         </div>
      </app-panel>
    </ng-container>

    <ng-template #registrationSuccess>
      <div class="registration-success">
        <app-panel>
          <div class="success-content">
            <div class="title">
              {{ 'BROKER-REGISTRATION.REGISTRATION-SUCCESS.TITLE' | translate }}
            </div>

            <div class="description">
              {{ 'BROKER-REGISTRATION.REGISTRATION-SUCCESS.DESCRIPTION' | translate }}
            </div>
          </div>
        </app-panel>
      </div>
    </ng-template>
  </div>
</div>